import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import SearchIcon from "@mui/icons-material/Search";
import { Card, Alert, Row, Col } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { DateRange, Visibility, VisibilityOff } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
import Autocomplete from "@mui/lab/Autocomplete";

import {
	resetGetVoucherList,
	getVoucherListReq
} from "../../redux/actions/getVoucherListAction";

import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import {
	resetVoucherDetails,
	getvoucherDetailsList
} from "../../redux/actions/voucherDetailsAction";
import { getCustomerIdAndNameList } from "../../redux/actions/getCustomerIdAndNameListAction";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});
const Vouchers = () => {
	const classes = useStyles();
	const navigate = useHistory();
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const [voucherId, setVoucherId] = useState("");
	const [customerId, setCustomerId] = useState("");
	const [statusType, setStatusType] = useState("");
	const [fromDateTime, setfromDateTime] = useState("00:00:00");
	const [toDateTime, settoDateTime] = useState("23:59:59");
	const [isLoading, setIsLoading] = useState(false);

	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getVoucherTransactionsRes = useSelector(
		({ getVoucherTransactions }) => getVoucherTransactions
	);
	// console.log("getVoucherTransactionsRes", getVoucherTransactionsRes);

	const [getVoucherListstatus, setGetVoucherListStatus] = useState(false);

	const [getVoucherListArray, setgetVoucherListArray] = useState([]);
	const [open, setOpen] = useState(null);
	const [vouchId, setVouchId] = useState('')

	const [getVoucherDetailsStatus, SetgetVoucherDetailsStatus] = useState(false);

	const [getVoucherDetailsArray, setgetVoucherDetailsArray] = useState([]);
	const [isMaskedEmail, setIsMaskedEmail] = useState(true);

	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);
	const getvoucherDetailsRes = useSelector(
		({ getvoucherDetails }) => getvoucherDetails
	);


	const onButtonClick = (vouchId) => {
		// console.log("vouchIdddddd", vouchId)
		if (open == vouchId) {
			setOpen(null)
		}
		else {
			setIsMaskedEmail(true)

			setOpen(vouchId)
		}
		setVouchId(vouchId)
		getVoucherDetailsReqApi(vouchId)
		// console.log("getVoucherDetailsArray", getVoucherDetailsArray);

	};

	const handleChange = ({ target: { name, value } }) => {
		// if (name === "customerId") {
		// 	// setCustomerId(value);
		// 	Util.verifyNumber(value)
		// 		? setCustomerId(value)
		// 		: setCustomerId(customerId);
		// }
		if (name === "customerId") {
			// console.log("CustIDDDD", customerId)
			setCustomerId(value)
		}

		if (name === "statusType") {
			// setStatusType(value);
			setStatusType(value == "All" ? "" : value);
		}

		if (name === "fromDateTime") {
			setfromDateTime(value);
		}

		if (name === "toDateTime") {
			settoDateTime(value);
		}

		if (name === "voucherId") {
			// setVoucherId(value);
			Util.verifyNumber(value) ? setVoucherId(value) : setVoucherId(voucherId);
		}
	};

	// const handleDateChange = (date) => {
	// 	setSelectedDate(date);
	// };
	const handleDateChange = (date) => {
		setSelectedDate(date);
		if(date > selectedToDate){
            setSelectedToDate(date)
        }
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	function filterWeekends(date) {
		return date.getDay() === 0 || date.getDay() === 6;
	}

	const getVoucherListRe = () => {
		if (!selectedDate || !selectedToDate || !fromDateTime || !toDateTime) {
			alert("Please enter a Date & Time..!!");
			return; // Stop the execution if "From Date" is not selected
		}
		setIsLoading(true);
		setGetVoucherListStatus(true);
		const getVoucherListReqIs = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			voucherTransVO: {
				startDate: moment(selectedDate).format("DD/MM/YYYY"),
				startTime: fromDateTime,
				endDate: moment(selectedToDate).format("DD/MM/YYYY"),
				endTime: toDateTime,
				customerId: customerId.split("-")[0] || "",
				voucherId: voucherId,
				status: statusType
			}
		};

		return dispatch(getVoucherListReq(getVoucherListReqIs, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			// getVoucherListRe();
		}
	}, [regenerateTokenRes.data.status]);

	const getVoucherListRes = useSelector(({ getVoucherList }) => getVoucherList);

	useEffect(() => {
		if (getVoucherListstatus) {
			if (getVoucherListRes.data.status == "success") {
				setIsLoading(false);
				setgetVoucherListArray(
					[].concat(getVoucherListRes.data.voucherListRequestVOList)
				);
			}
			if (getVoucherListRes.data.status == "Failed") {
				setIsLoading(false);
				setgetVoucherListArray(getVoucherListRes.data);
				setGetVoucherListStatus(false);
				NotificationPopups("error", "Failed", getVoucherListRes.data.status);
				if (
					getVoucherListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getVoucherListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getVoucherListRes.data.status == "failed") {
				setIsLoading(false);
				setgetVoucherListArray(getVoucherListRes.data);
				setGetVoucherListStatus(false);
				NotificationPopups("error", "Failed", getVoucherListRes.data.status);
				if (
					getVoucherListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getVoucherListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getVoucherListRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setgetVoucherListArray(getVoucherListRes.data);
				setGetVoucherListStatus(false);
				NotificationPopups("error", "Failed", getVoucherListRes.data.status);
			}
		}
	}, [getVoucherListRes.data.status]);

	useEffect(() => {
		if (getVoucherListRes.data.status == "success") {
			setPage(0);
		}
	}, [getVoucherListRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const getVoucherDetailsReqApi = (vouchId) => {
		SetgetVoucherDetailsStatus(true);
		const getvoucherDetailsListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			voucherTransVO: {
				voucherId: vouchId
			}
		};
		return dispatch(
			getvoucherDetailsList(
				getvoucherDetailsListReq,
				regenerateTokenRes.data.AuthToken
			)
		);
		// console.log("ggeeetttt", getvoucherDetailsListReq)
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getVoucherDetailsReqApi();
		}
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		if (getVoucherDetailsStatus) {
			if (getvoucherDetailsRes.data.status == "success") {
				// console.log("vvooouvheeerr", getVoucherDetailsArray)
				setgetVoucherDetailsArray(
					getvoucherDetailsRes.data.voucherListRequestVO
				);
			}
			if (getvoucherDetailsRes.data.status == "Failed") {
				setgetVoucherDetailsArray(getvoucherDetailsRes.data);
				if (
					getvoucherDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getvoucherDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getvoucherDetailsRes.data.status == "failed") {
				setgetVoucherDetailsArray(getvoucherDetailsRes.data);
				if (
					getvoucherDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getvoucherDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getvoucherDetailsRes.data.status == "NOT FOUND") {
				setgetVoucherDetailsArray(getvoucherDetailsRes.data);
			}
		}
	}, [getvoucherDetailsRes.data.status]);

	// const sendCustomerId = (id) => {
	// 	navigate.push({
	// 		pathname: `/index/voucherDetails`,
	// 		search: `?userId=${id}`
	// 	});
	// };

	useEffect(() => {
		if (getCustomerIdAndNameListRes.data.status === "Success") {
			//console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
		}
	}, [getCustomerIdAndNameListRes.data.status])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);


	const filterOptionsL = (options, { inputValue }) => {
		//console.log(options, inputValue, "optionsss")
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="From Date"
										format="MM/dd/yyyy"
										value={selectedDate}
										onChange={handleDateChange}
										disableFuture={true}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="HH:MM:SS"
								variant="standard"
								type="tel"
								fullWidth
								value={fromDateTime}
								name="fromDateTime"
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							
								style={{ marginTop: "3px" }}
							/>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="To Date"
										format="MM/dd/yyyy"
										value={selectedToDate}
										onChange={handleToDateChange}
										disableFuture={true}
										minDate={selectedDate}

									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="HH:MM:SS"
								type="tel"
								variant="standard"

								fullWidth
								value={toDateTime}
								name="toDateTime"
								onChange={handleChange}
								style={{ marginTop: "3px" }}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Voucher ID"
								variant="standard"

								type="text"
								fullWidth
								value={voucherId || ""}
								name="voucherId"
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>

						{/* <Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Customer ID"
								variant="standard"

								type="tel"
								fullWidth
								value={customerId}
								name="customerId"
								onChange={handleChange}
							/>
						</Grid> */}
						
						<Grid item xs={12} sm={12} md={3} lg={3}>
								<Autocomplete
									id="combo-box-demo"
									options={[].concat(
										getCustomerIdAndNameListRes.data.currencyList || [""]
									)}
									getOptionLabel={(option) => option}
									filterOptions={filterOptionsL}
									value={customerId}
									onChange={handleChange}
									onInputChange={(event, newInputValue) => {
										setCustomerId(newInputValue);
									}}
									renderInput={(params) => (
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Customer ID"
											style={{ marginTop: "8px" }}
											// required
											type="tel"
											fullWidth
											{...params}

											name="customerId"

											variant="standard"
											sx={{
												"& .MuiInput-underline:before": {
												  borderBottomColor: "gray", // White color for the underline before focus
												},
												"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												  borderBottomColor: "gray", // White color on hover
												},
												"& .MuiInput-underline:after": {
												  borderBottomColor: "gray", // White color after focus
												},
											  }}
										/>
									)}
								/>
							</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Status"
								type="name"
								fullWidth
								variant="standard"
								name="statusType"
								// value={statusType || ""}
								defaultValue={"All" || statusType}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="All" selected="All">
									All
								</MenuItem>
								<MenuItem value="ACTIVE">Active</MenuItem>
								<MenuItem value="REDEEMED">Redeemed</MenuItem>
								<MenuItem value="EXPIRED">Expired</MenuItem>
								<MenuItem value="FAILED">Failed</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							{/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                  marginTop: "1rem",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getVoucherListRe}
              >
                Search
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getVoucherListRe}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>

					{/* <Grid
            container
            style={{
              padding: "10px",
              marginTop: "1.5rem",
              marginBottom: "15px",
            }}
          >
            <Grid item md={5}>
              <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getVoucherListRe}
              >
                Search
              </Button>
            </Grid>
            <Grid item md={7}></Grid>
          </Grid> */}
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getVoucherListArray.length == undefined || !getVoucherListstatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Voucher List
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Voucher List
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}

											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Voucher Id{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Customer Id
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Voucher Number
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Amount
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Status
											</TableCell>

											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Creation Date
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Activation Date
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Redeem Date
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getVoucherListArray &&
											[]
												.concat(getVoucherListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<>
														<TableRow key={index}>
															<TableCell style={{ borderBottom: "0" }}>
																<IconButton
																	aria-label="expand row"
																	size="small"
																	onClick={() => onButtonClick(row.voucherId)}
																>
																	{open == row.voucherId ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
																</IconButton>
															</TableCell>
															{/* <TableCell align="center">
                                <CustomButton
                                  // style={{
                                  //   marginTop: "1rem",
                                  //   marginLeft: "1rem",
                                  // }}
                                  onClick={() => sendCustomerId(row.voucherId)}
                                >
                                  {row.voucherId}
                                </CustomButton>
                              </TableCell> */}
															<TableCell
																align="center"
																className="themeText"
																style={{
																	marginTop: "1rem",
																	// marginLeft: "rem",
																	// color: "#00b9f5",
																	cursor: "pointer",
																	fontWeight: "600",
																	borderBottom: "0"
																}}
															// onClick={() => sendCustomerId(row.voucherId)}
															>
																{row.voucherId === '' ? '-' : row.voucherId}
															</TableCell>
															<TableCell align="center" style={{ borderBottom: "0" }}>
																{row.customerId === '' ? '-' : row.customerId}
															</TableCell>
															<TableCell align="center" style={{ borderBottom: "0" }}>
																{row.voucherNumber === '' ? '-' : row.voucherNumber}
															</TableCell>
															<TableCell align="center" style={{ borderBottom: "0" }}>
																{row.amount === '' ? '-' : row.amount}
															</TableCell>
															<TableCell align="center" style={{ borderBottom: "0" }}>
																{row.currency === '' ? '-' : row.currency}
															</TableCell>

															<TableCell align="center" style={{ borderBottom: "0" }}>
																{row.status === '' ? '-' : row.status}
															</TableCell>
															<TableCell align="center" style={{ borderBottom: "0" }}>
																{row.creationDate === '' ? '-' : row.creationDate}
															</TableCell>
															<TableCell align="center" style={{ borderBottom: "0" }}>
																{row.activationDate === '' ? '-' : row.activationDate}
															</TableCell>
															<TableCell align="center" style={{ borderBottom: "0" }}>
																{/* {row.redeemDate ? row.redeemDate : ''} */}
																{row.redeemDate === '' ? '-' : row.redeemDate}
															</TableCell>
														</TableRow>
														<TableRow>
															<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
																<Collapse
																	in={open == row.voucherId}

																	timeout="auto"
																	// onClick={() => onButtonClick(row.fromCustomerId
																	// )}
																	unmountOnExit
																>
																	<Box margin={4}>
																		{getvoucherDetailsRes.data
																			.voucherListRequestVO &&
																			getvoucherDetailsRes.data
																				.voucherListRequestVO ? (
																			<>
																				{getVoucherDetailsArray && (
																					<Table
																						className={classes.table}
																						aria-label="a dense table"
																						style={{ whiteSpace: "nowrap" }}

																					>
																						<TableBody>
																							{getVoucherDetailsArray &&
																								[].concat(getVoucherDetailsArray)
																									.map((row, index) => (
																										<TableRow key={index}>






																											<Row>
																												<Col md={12}>
																													<Typography
																														variant="h6"
																														component="div"
																														className="mt-1"
																														style={{
																															fontSize: "1.4rem",
																															// paddingTop: "1%",
																															// paddingBottom: "1.5%",

																														}}
																													>
																														Customer Details
																													</Typography>
																													<hr />

																													{getVoucherDetailsArray.voucherTransVO &&
																														[]
																															.concat(getVoucherDetailsArray.voucherTransVO)
																															.map((row, index) => (
																																<Row key={index}>
																																	<Col md={12}>
																																		<Row>




																																			<Col md={6} class="detail-info row">
																																				<Row>

																																					<Col md={6}>Customer Id</Col>
																																					<Col md={6}>
																																						{!row.userId || row.userId == ""
																																							? "-"
																																							: row.userId}
																																					</Col>
																																				</Row>
																																			</Col>



																																			<Col md={6} class="detail-info row">
																																				<Row>

																																					<Col md={6}>Customer Name</Col>
																																					<Col md={6}>
																																						{!row.customerName || row.customerName == ""
																																							? "-"
																																							: row.customerName}
																																					</Col>
																																				</Row>
																																			</Col>
																																		</Row>
																																		<hr />
																																		<Row>



																																			<Col md={6} class="detail-info row">
																																				<Row>

																																					<Col md={6}>Country Code</Col>
																																					<Col md={6}>
																																						{!row.cardCountry || row.cardCountry == ""
																																							? "-"
																																							: row.cardCountry}
																																					</Col>
																																				</Row>
																																			</Col>
																																			<Col md={6} class="detail-info row">
																																				<Row>

																																					<Col md={6}>Customer Email</Col>
																																					<Col md={5}>
																																						{/* {!row.emailAddress || row.emailAddress == ""
																																							? "-"
																																							: row.emailAddress} */}
																																						{row.emailAddress && isMaskedEmail ? row.emailAddress.substring(0, 1) + "xxxx" + row.emailAddress.substring(row.emailAddress.lastIndexOf("@"), row.emailAddress.length) : row.emailAddress}

																																					</Col>
																																					<Col md={1}><span style={{ cursor: "pointer" }} onClick={() => setIsMaskedEmail(!isMaskedEmail)}> {isMaskedEmail ? <VisibilityOff className="EyeIcons" /> : <Visibility className="EyeIcons" />}
																																					</span> </Col>
																																				</Row>
																																			</Col>
																																		</Row>


																																	</Col>

																																</Row>
																															))
																													}


																												</Col>
																											</Row>
																											<hr />
																											{/* <Row >
																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Customer Id	</Col>
																																<Col md={6}>
																																	{!row.userId || row.userId == ""
																																		? "-"
																																		: row.userId}
																																</Col>
																															</Row>
																														</Col>



																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Customer Name</Col>
																																<Col md={6}>
																																	{!row.customerName || row.customerName == ""
																																		? "-"
																																		: row.customerName}
																																</Col>
																															</Row>
																														</Col>
																													</Row>
																													<hr />
																													<Row >
																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Country Code</Col>
																																<Col md={6}>
																																	{!row.cardCountry || row.cardCountry == ""
																																		? "-"
																																		: row.cardCountry}
																																</Col>
																															</Row>
																														</Col>



																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Customer Email</Col>
																																<Col md={6}>
																																	{!row.emailAddress || row.emailAddress == ""
																																		? "-"
																																		: row.emailAddress}
																																</Col>
																															</Row>
																														</Col>
																													</Row>

																												</Col> */}


																											<Row>
																												<Col md={12}>
																													<Typography
																														variant="h6"
																														component="div"
																														className="mt-1"
																														style={{
																															fontSize: "1.4rem",
																															// paddingTop: "1%",
																															// paddingBottom: "1.5%",

																														}}
																													>
																														Voucher Details
																													</Typography>
																													<hr />
																													<Row >
																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Voucher Id</Col>
																																<Col md={6}>
																																	{!row.voucherId || row.voucherId == ""
																																		? "-"
																																		: row.voucherId}
																																</Col>
																															</Row>
																														</Col>



																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Voucher Number</Col>
																																<Col md={6}>
																																	{!row.voucherNumber || row.voucherNumber == ""
																																		? "-"
																																		: row.voucherNumber}
																																</Col>
																															</Row>
																														</Col>
																													</Row>
																													<hr />
																													<Row >
																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Voucher Type</Col>
																																<Col md={6}>
																																	{!row.voucherType || row.voucherType == ""
																																		? "-"
																																		: row.voucherType}
																																</Col>
																															</Row>
																														</Col>



																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Voucher Status</Col>
																																<Col md={6}>
																																	{!row.status || row.status == ""
																																		? "-"
																																		: row.status}
																																</Col>
																															</Row>
																														</Col>
																													</Row>


																													<hr />
																													<Row >
																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Voucher Amount</Col>
																																<Col md={6}>
																																	{!row.amount || row.amount == ""
																																		? "-"
																																		: row.amount}
																																</Col>
																															</Row>
																														</Col>



																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Voucher Currency</Col>
																																<Col md={6}>
																																	{!row.currency || row.currency == ""
																																		? "-"
																																		: row.currency}
																																</Col>
																															</Row>
																														</Col>
																													</Row>
																													<hr />

																													<Row >
																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Creation Date</Col>
																																<Col md={6}>
																																	{!row.creationDate || row.creationDate == ""
																																		? "-"
																																		: row.creationDate}
																																</Col>
																															</Row>
																														</Col>



																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Activation Date</Col>
																																<Col md={6}>
																																	{!row.activationDate || row.activationDate == ""
																																		? "-"
																																		: row.activationDate}
																																</Col>
																															</Row>
																														</Col>
																													</Row>
																													<hr />
																													<Row >
																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Expiry Date</Col>
																																<Col md={6}>
																																	{!row.expiryDate || row.expiryDate == ""
																																		? "-"
																																		: row.expiryDate}
																																</Col>
																															</Row>
																														</Col>



																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Redeem Date</Col>
																																<Col md={6}>
																																	{!row.redeemDate || row.redeemDate == ""
																																		? "-"
																																		: row.redeemDate}
																																</Col>
																															</Row>
																														</Col>
																													</Row>
																												</Col>
																											</Row>
																											<hr />



																											<Row>
																												<Col md={12}>
																													<Typography
																														variant="h6"
																														component="div"
																														className="mt-1"
																														style={{
																															fontSize: "1.4rem",
																															paddingTop: "1%",
																															// paddingBottom: "1.5%",

																														}}
																													>
																														Voucher History
																													</Typography>
																													<hr />
																													<div className="ViewTranHistory">
																														<TableContainer component={Paper} >
																															<Table
																																className={classes.table}
																																aria-label="a dense table"
																																style={{ whiteSpace: "nowrap" }}
																															>
																																<TableHead>
																																	<TableRow className="">
																																		<TableCell
																																			align="center"
																																			style={{ color: "black" }}
																																		>
																																			Status{" "}
																																		</TableCell>
																																		<TableCell
																																			align="center"
																																			style={{ color: "black" }}
																																		>
																																			Timestamp
																																		</TableCell>
																																		<TableCell
																																			align="center"
																																			style={{ color: "black" }}
																																		>
																																			Voucher Currency
																																		</TableCell>
																																		<TableCell
																																			align="center"
																																			style={{ color: "black" }}
																																		>
																																			Voucher Amount
																																		</TableCell>
																																		<TableCell
																																			align="center"
																																			style={{ color: "black" }}
																																		>
																																			Reedem Currency
																																		</TableCell>
																																		<TableCell
																																			align="center"
																																			style={{ color: "black" }}
																																		>
																																			Reedem Amount
																																		</TableCell>
																																	</TableRow>
																																</TableHead>
																																<TableBody>
																																	{getVoucherDetailsArray.voucherHistoryVOList &&
																																		[]
																																			.concat(getVoucherDetailsArray.voucherHistoryVOList)
																																			.map((row, index) => (
																																				<TableRow key={index}>
																																					<TableCell align="center">
																																						{row.status ? row.status : "-"}
																																					</TableCell>
																																					<TableCell align="center">
																																						{row.timeStamp ? row.timeStamp : "-"}
																																					</TableCell>
																																					<TableCell align="center">
																																						{row.purchaseCurrency ? row.purchaseCurrency : "-"}
																																					</TableCell>
																																					<TableCell align="center">
																																						{row.purchaseAmount ? row.purchaseAmount : "-"}
																																					</TableCell>
																																					<TableCell align="center">
																																						{row.redeemCurrency ? row.redeemCurrency : "-"}
																																					</TableCell>
																																					<TableCell align="center">
																																						{row.redeemAmount ? row.redeemAmount : "-"}
																																					</TableCell>

																																				</TableRow>
																																			))
																																	}
																																</TableBody>
																															</Table>
																														</TableContainer>
																													</div>
																												</Col>
																											</Row>


																											{getVoucherDetailsArray.list &&
																												getVoucherDetailsArray.list ? (
																												<Row>
																													<Col md={12}>

																														<Typography
																															variant="h6"
																															component="div"
																															className="mt-1"
																															style={{
																																fontSize: "1.4rem",
																																paddingTop: "1%",
																																// paddingBottom: "1.5%",

																															}}
																														>
																															Transaction Details
																														</Typography>
																														<hr />
																														<div className="ViewTranHistory">
																															<TableContainer component={Paper} >
																																<Table
																																	className={classes.table}
																																	aria-label="a dense table"
																																	style={{ whiteSpace: "nowrap" }}
																																>
																																	<TableHead>
																																		<TableRow className="">
																																			<TableCell
																																				align="center"
																																				style={{ color: "black" }}
																																			>
																																				Tracking ID
																																			</TableCell>
																																			<TableCell
																																				align="center"
																																				style={{ color: "black" }}
																																			>
																																				Voucher Amount
																																			</TableCell>
																																			<TableCell
																																				align="center"
																																				style={{ color: "black" }}
																																			>
																																				Voucher currency
																																			</TableCell>
																																			<TableCell
																																				align="center"
																																				style={{ color: "black" }}
																																			>
																																				Action
																																			</TableCell>
																																			<TableCell
																																				align="center"
																																				style={{ color: "black" }}
																																			>
																																				Reedem Amount
																																			</TableCell>
																																			<TableCell
																																				align="center"
																																				style={{ color: "black" }}
																																			>
																																				Reedem Currency
																																			</TableCell>
																																			<TableCell
																																				align="center"
																																				style={{ color: "black" }}
																																			>
																																				Transaction Date
																																			</TableCell>
																																			<TableCell
																																				align="center"
																																				style={{ color: "black" }}
																																			>
																																				Status
																																			</TableCell>
																																		</TableRow>
																																	</TableHead>
																																	<TableBody>

																																		{getVoucherDetailsArray.list &&
																																			[]
																																				.concat(getVoucherDetailsArray.list)
																																				.map((row, index) => (
																																					<TableRow key={index}>
																																						<TableCell align="center">
																																							{row.trackingId ? row.trackingId : "-"}
																																						</TableCell>
																																						<TableCell align="center">
																																							{row.voucherAmount ? row.voucherAmount : "-"}
																																						</TableCell>
																																						<TableCell align="center">
																																							{row.voucherCurrency ? row.voucherCurrency : "-"}
																																						</TableCell>
																																						<TableCell align="center">
																																							{row.action ? row.action : "-"}
																																						</TableCell>
																																						<TableCell align="center">
																																							{row.custAmount ? row.custAmount : "-"}
																																						</TableCell>
																																						<TableCell align="center">
																																							{row.custCurrency ? row.custCurrency : "-"}
																																						</TableCell>
																																						<TableCell align="center">
																																							{row.timestamp ? row.timestamp : "-"}
																																						</TableCell>
																																						<TableCell align="center">
																																							{row.status ? row.status : "-"}
																																						</TableCell>

																																					</TableRow>
																																				))
																																		}
																																	</TableBody>
																																</Table>
																															</TableContainer>
																														</div>
																													</Col>
																												</Row>



																											) : (
																												""
																											)
																											}

																										</TableRow>

																									))
																							}
																						</TableBody>
																					</Table>
																				)}
																			</>
																		) : (
																			""
																		)
																		}
																	</Box>
																</Collapse>
															</TableCell>
														</TableRow>
													</>


												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getVoucherListArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>
		</>
	);
};

export default Vouchers;
